<template>
  <div class="v-tabs-container">
    <ul :class="`v-tabs ${this.$props.class ?? ''}`">
      <li v-for="tab in tabs" :class="{ 'is-active': tab.name===this.selectedTabName, 'v-tabs-item':true }" @click.prevent="selectTab(tab)">
        <div class="v-tabs-item-link">{{ tab.name }}</div>
      </li>
    </ul>
  </div>

  <div class="tabs-details">
    <slot></slot>
  </div>
</template>

<script>
import {ref, provide} from 'vue';

export default {
  name: "Tabs",
  props: {
    class: {
      type: String,
      default: null
    },
  },
  setup(props, {slots}) {
    const tabs = ref(slots.default().map(tab => {
      return {name: tab.props.name};
    }));

    const selectedTabName = ref(tabs.value[0].name);

    provide('tabName', selectedTabName);

    return {
      tabs,
      selectedTabName
    };
  },
  methods: {
    selectTab(selectedTab) {
      this.selectedTabName = selectedTab.name;
      this.$emit('select');
    }
  }
}
</script>

<style scoped>

</style>